import { apiClient } from '../client';
import type { Special } from './bars';

interface SpecialsListResponse {
  success: boolean;
  specials: (Special & { barName?: string; barAddress?: string; barLogoUrl?: string; distance?: number })[];
  total: number;
  limit: number;
  offset: number;
}

interface ListSpecialsParams {
  type?: 'drink' | 'food';
  lat?: number;
  lng?: number;
  radius?: number;
  limit?: number;
  offset?: number;
}

export const specialsApi = {
  list: async (params: ListSpecialsParams = {}): Promise<SpecialsListResponse> => {
    const { data } = await apiClient.get<SpecialsListResponse>('/v1/specials', {
      params,
    });
    return data;
  },

  getById: async (id: string) => {
    const { data } = await apiClient.get(`/v1/specials/${id}`);
    return data;
  },
};
